import PropTypes from "prop-types";
import I18n from "@/i18n-js/instance";
import { isDraftSpace } from "@/react/helpers/spaceHelpers";
import { toLocaleString } from "@circle-react/helpers/number";
import { StatItem } from "./StatItem";

export const Stats = ({ space, stats }) => (
  <div className="grid grid-cols-1 gap-6 py-2 md:grid-cols-2">
    <StatItem
      title={I18n.t(
        `courses.admin_summary.${
          isDraftSpace(space) ? "waitlist" : "students"
        }`,
      )}
      value={toLocaleString(stats?.students_count || 0)}
      tooltipText={
        isDraftSpace(space)
          ? I18n.t("courses.admin_summary.waitlist_tooltip")
          : ""
      }
      tooltipIcon="16-clock"
    />
    <StatItem
      title={I18n.t("courses.admin_summary.completion_rate")}
      value={stats?.average_completion_rate || "0%"}
    />
  </div>
);

Stats.propTypes = {
  space: PropTypes.object.isRequired,
  stats: PropTypes.shape({
    students_count: PropTypes.number,
    average_completion_rate: PropTypes.string,
  }),
};
